export default {
  // report
  REPORT: {
    chapter: {
      ___appendix: '附錄',
      title: {
        ___subject: '受檢者基本資訊',
        ___disease_diagnosis: '疾病診斷',
        ___disease_diagnosis_lite: '候選清單',
        ___active_screening: '主動篩查',
        ___cause_screening: '帶因篩查',
        ___acmg_incidental: 'ACMG偶然發現',
        ___custom1: '自訂頁面1',
        ___custom2: '自訂頁面2',
        ___custom3: '自訂頁面3',
        ___constitution: '體質相關基因',
        ___drug_meta: '藥物代謝',
        ___method: '檢測方法',
        ___appendix_disease_gene: '疾病診斷之基因清單',
        ___appendix_disease_gene_lite: '基因清單',
        ___appendix_us_gene: '美國人類遺傳學會規範之基因'
      },
      item: {
        title: {
          ___resultSummary: '結果表格',
          ___interpretation: '文字說明'
        },
        variant: {
          ___empty: '尚未加入任何位點'
        }
      },
      header: {
        ___info01: 'Report Date',
        ___info02: 'Sample ID'
      },
      footer: {
        ___info01: '＊ 本報告內容須經專業醫療人員解釋。',
        ___info02: '300 新竹市東區慈雲路118號17樓之10 | 康百事生物資訊 | 03-574-5009'
      },
      basicInfo: {
        ___title: '受檢者基本資訊',
        form: {
          title: {
            ___case_id: '姓名',
            ___sex: '性別',
            ___age: '年齡',
            ___testing_date: '檢測日期',
            ___testing_category: '檢測種類',
            ___sequencing_range: '定序範圍',
            ___sequencing_tech: '定序技術',
            ___doctor_name: '送檢醫師',
            ___organization: '機構院所',
            ___medical_number: '病歷號',
            ___family_medical_history: '備註'
          }
        }
      },
      variantResult: {
        mainData: {
          default: {
            ___title: '文字說明',
            ___contentTitle01: '本次基因檢測中，共發現 <b>{count}</b> 個基因攜帶可能致病的突變',
            ___contentTitle02: '其中<b> {count} </b>個位於粒線體 DNA 區域',
            detail: {
              title: {
                ___ClinVar: 'ClinVar 資料庫登載為',
                ___ClinVar_empty: 'ClinVar 資料庫無登載',
                ___ACMG: 'ACMG 指南預測為',
                ___OMIM: 'OMIM 資料庫記載可能相關的疾病為，',
                ___OMIM_empty: 'OMIM 資料庫未記載可能相關的疾病',
                ___Orphanet: 'Orphanet 資料庫記載可能相關的疾病為，',
                ___Orphanet_empty: 'Orphanet 資料庫未記載可能相關的疾病'
              }
            }
          },
          cnv: {
            ___title: 'CNV文字說明',
            ___contentTitle01: '本次基因檢測中，共發現 <b>{count}</b> 個區域產生可能致病的突變',
            detail: {
              title: {
                ___genes: '該區域涵蓋之相關基因為',
                ___OMIM: 'OMIM 資料庫記載可能相關的疾病為，',
                ___OMIM_empty: 'OMIM 資料庫未記載可能相關的疾病'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: '結果表格',
        ___variantContainerTitle: '相關疾病與表型',
        ___phenotypeTableEmpty: '無資料',
        ___variantNotePlaceholder: '備註',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar登載',
            ___ACMG: 'ACMG指南預測',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___Population_Databases: '變異頻率',
            ___Prediction_Score: '蛋白質功能預測',
            ___Sequencing_Quality: '定序品質'
          }
        },
        info: {
          title: {
            ___phenotypes: '臨床表徵',
            ___gene_panels: '基因套組',
            ___related_genes: '基因範圍'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: '位置',
            ___custom_details_Rank: '外顯子/<br>內含子編號',
            ___custom_details_HGVSm: '核苷酸變異位點<br>HGVSm',
            ___custom_details_HGVSc: '核苷酸變異位點<br>HGVSc',
            ___custom_details_HGVSp: '胺基酸變異位點<br>HGVSp',
            ___custom_details_GT_AF: '異質性程度 (%)',
            ___custom_details_GT: '合子型',
            ___custom_details_Consequence: '變異類型',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: 'Parental<br>Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '臨床表徵',
            ___id: 'OMIM表徵編號',
            ___Inheritance: '遺傳模式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '臨床表徵',
            ___id: 'ORPHA表徵編號'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: '台灣人基因型頻率',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_addAF: 'BayesDel addAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'CNV 結果表格',
        ___symbolContainerTitle: '相關基因',
        ___geneContainerTitle: '相關疾病與表型',
        ___phenotypeTableEmpty: '無資料',
        ___cnvNotePlaceholder: '備註',
        cnvTable: {
          title: {
            ___Position: '變異區域',
            ___Exon_Intron: '外顯子 / 內含子編號',
            ___Zygosity: '合子型',
            ___Consequence: '變異類型',
            ___Fragment_size: '片段大小',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '臨床表徵',
            ___id: 'OMIM表徵編號',
            ___Inheritance: '遺傳模式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '臨床表徵',
            ___id: 'ORPHA表徵編號'
          }
        }
      },
      constitutionGene: {
        ___title: '體質相關基因',
        ___subTitle: '許多基因被發現與過敏、⾎栓、酒精不耐有關，這些重要資訊能提醒你更多⽣活注意事項。',
        mainData: {
          testSummary: {
            ___title: '檢測結果說明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '詳細檢測項目'
          }
        },
        table: {
          title: {
            ___title: '檢測項目',
            ___SYMBOL: '檢測基因',
            ___Location2: '檢測位點',
            ___Result: '檢測結果'
          },
          value: {
            Result: {
              ___true: '檢出',
              ___false: '未檢出'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: '藥物代謝分析',
        ___subTitle: '藥物相關基因可提供醫師作為參考，選擇對⾃⼰最適合的藥物，預防嚴重副作⽤、毒性，並達到最佳的治療反應。同⼀種藥物，有些⼈⽤藥後全⾝過敏或副作⽤特別強，是因為⽤了不適合⾃⼰的藥物或劑量。',
        customInfos: {
          ___info01: '紅色標示之基因型為檢測出之風險基因型。'
        },
        mainData: {
          testSummary: {
            ___title: '檢測結果說明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '詳細檢測項目'
          }
        },
        table: {
          title: {
            ___name: '藥物名稱',
            ___type: '藥物作用',
            ___SYMBOL: '檢測基因',
            ___risk_genotype2: '檢測位點',
            ___clinical_phenotype: '臨床意義',
            ___Result: '檢測結果'
          },
          value: {
            Result: {
              ___true: '檢出',
              ___false: '未檢出'
            }
          }
        }
      },
      detectMethod: {
        ___title: '檢測方法、檢測品質與分析軟體版本資訊',
        ___subTitle: '檢測方法說明',
        table: {
          title: {
            ___library_kit: '樣本庫試劑組',
            ___sequencing_platform: '定序平台',
            ___sequencing_length: '定序長度',
            ___average_sequencing_length: '平均定序深度',
            ___pct_target_bases_xx: '所有定序範圍內之<br>20X檢測覆蓋率',
            ___reference: '參考序列',
            ___alignment_version: '序列比對<br>Alignment軟體',
            ___variant_calling_version: '序列比對<br>Variant Calling軟體',
            ___jannovar_version: '變異點位註解軟體<br>jANNOVAR 版本',
            ___vep_version: '變異點位註解軟體<br>VEP 版本',
            ___hpo_version: 'HPO版本',
            ___omim_version: 'OMIM版本',
            ___dbsnp_version: 'dbSNP版本',
            ___clinvar_version: 'ClinVar版本',
            ___mitomap_version: 'MITOMAP版本',
            ___dbnsfp_version: 'dbNSFP 版本'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: '檢測方法注釋',
        list: {
          list01: {
            ___title: '檢測結果比對參考序列為人類GRCh38 (或稱 hg38) 版本。'
          },
          list02: {
            ___title: '<b>基因型 (genotype)</b>',
            detail: {
              detail01: {
                ___title: 'Homozygous：在2條相對的對偶基因(allele)中，皆出現此基因變異位點。'
              },
              detail02: {
                ___title: 'Heterozygous：此基因變異位點僅出於1條對偶基因中，另1條對偶基因上無位點變異。'
              },
              detail03: {
                ___title: 'Hemizygous：在男性受測者中，因僅有1條X或Y染色體，稱為半合子。若基因變異位點出現於性染色體上，則以Hemizygous表示之。'
              }
            }
          },
          list03: {
            ___title: '<b>臨床意義 (clinical significance)</b>：主要引用ClinVar資料庫註解或依據2015年版ACMG準則進行分類',
            detail: {
              detail01: {
                ___title: 'Pathogenic：此基因變異位點具致病性。'
              },
              detail02: {
                ___title: 'Likely pathogenic：此基因變異位點可能具致病性。'
              },
              detail03: {
                ___title: 'Uncertain significance：此基因變異位點對於臨床上的影響目前尚無定論。'
              },
              detail04: {
                ___title: 'Likely benign：此基因變異位點可能不具致病性。'
              },
              detail05: {
                ___title: 'Benign：此基因變異位點不具致病性。'
              },
              detail06: {
                ___title: 'Conflicting interpretations of pathogenicity：此基因變異位點對於臨床上影響程度的定義並未有一致性解釋，有的文獻認為具致病性，有的文獻則認為不具致病性。'
              },
              detail07: {
                ___title: 'Disease-associated polymorphism：有文獻報導此基因多型性與疾病有顯著相關性。'
              },
              detail08: {
                ___title: 'SNP：在1000 Genomes資料庫中，此基因變異點在東南族群 (East Asian, EAS) 的發生比例大於1%，並無與疾病相關之文獻報導。'
              },
              detail09: {
                ___title: 'Drug response：此基因變異位點會影響藥物反應，可能干擾藥物療效或藥物副作用的產生與否有關。'
              }
            }
          },
          list04: {
            ___title: '<b>參考資料</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS：在1000 Genomes資料庫中，為此基因變異位點在東亞族 (East Asian, EAS) 的基因型比例。'
              },
              detail02: {
                ___title: 'gnomAD EAS：在 gnomAD 資料庫，為此基因變異位點在東亞族 (East Asian, EAS) 的基因型比例。'
              },
              detail03: {
                ___title: 'Taiwan BioBank: 在臺灣人體生物資料庫中，為此基因變異位點的基因型比例。臨床意義正確性仍無法確認，僅供參考。'
              },
              detail04: {
                ___title: '參考文獻：報導過此突變位點文獻，會列出文獻第一作者、出版年份、期刊名稱、卷號、和起始碼。'
              },
              detail05: {
                ___title: 'SIFT 與 PolyPhen-2 為預測胺基酸變異對於臨床上影響程度的 2 種統計工具。在 SIFT 中將預測結果標示為「有害」(Damaing) 或「無害」(Tolerated)，括弧內的數字為統計結果 ; 在 PolyPhen-2 中，將預測結果標示為「有害」(Damaging)、「可能有害」(Possibly damaging) 和「無害」(Benign)，括弧內的數字為統計結果，然而此預測結果缺乏對於蛋白質或基因學研究的相關證據，其預測出的臨床意義正確性仍無法確認，僅供參考。'
              }
            }
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: '疾病診斷之基因清單',
        ___title_lite: '基因清單',
        ___geneListTitle01: '覆蓋率 ≥ {cov}之基因',
        ___geneListTitle02: '覆蓋率未達{cov}之基因'
      },
      attachmentASoHGGene: {
        ___title: '美國人類遺傳學會規範之基因清單'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/_report/tc/lang.js